import {isPhone as userAgentisPhone} from '../useragent';

import {readable} from 'svelte/store';

const initial = userAgentisPhone;

export const isPhone = readable(initial, (set) => {
    let current = initial;
    const update = () => {
        const style = getComputedStyle(document.documentElement);
        const phoneMaxWidth = parseInt(style.getPropertyValue('--phone-max-width')) || 0;
        const next = window.innerWidth <= phoneMaxWidth;
        if(next !== current) {
            current = next;
            set(next);
        }
    };
    window.addEventListener('resize', update);
    return () => {
        window.removeEventListener('resize', update);
    };
});
